<template>
  <header class="adm-topbar">
    <div class="adm-topbar__titles">
      <span class="adm-topbar__super">Parkos Admin</span>
      <span class="adm-topbar__title">{{ title }}</span>
    </div>
    <div v-if="user" class="adm-topbar__avatar" :style="{ backgroundColor: user.avatarColor || '#e84545' }" :title="user.name + ' · ' + user.email">
      {{ initials(user.name) }}
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue'
import { useSuperadminStore } from '@/services/superadminStore'
import { initials } from './adminFormat'

defineProps({ title: { type: String, default: '' } })
const { admin } = useSuperadminStore()
const user = computed(() => admin.user)
</script>

<style scoped>
.adm-topbar {
  display: flex; align-items: center; gap: 12px; height: 56px; padding: 0 20px; flex-shrink: 0;
  background: #1e3a5f; border-bottom: 3px solid #e84545;
}
.adm-topbar__titles { flex: 1; min-width: 0; display: flex; flex-direction: column; }
.adm-topbar__super { font: 400 10px Inter, sans-serif; color: rgba(255, 255, 255, 0.6); }
.adm-topbar__title { font: 700 15px var(--font-display); color: #fff; line-height: 1.2; }
.adm-topbar__avatar {
  width: 32px; height: 32px; border-radius: 50%; flex-shrink: 0; display: flex; align-items: center; justify-content: center;
  color: #fff; font: 600 11px Inter, sans-serif;
}
</style>